import { createSlice } from '@reduxjs/toolkit';
import { getAuditLogsApi } from '../../../rtk-apis/auditLogs/getAuditLogs';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getAuditLogsSlice = createSlice({
  name: 'getUser',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAuditLogsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAuditLogsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg || 'Audit Logs fetched successfully.';
      })
      .addCase(getAuditLogsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.result = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getAuditLogsSlice.actions;
export default getAuditLogsSlice.reducer;
